import type {
  GoogleExchangeResponse,
  MeResponse,
  ApiError,
} from '@onlybans/shared'

const API_BASE = import.meta.env.VITE_API_BASE as string

class ApiClientError extends Error {
  constructor(public readonly error: ApiError, public readonly status: number) {
    super(error.message)
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  })
  if (!res.ok) {
    let err: ApiError
    try {
      err = (await res.json()) as ApiError
    } catch {
      err = { code: 'internal', message: res.statusText }
    }
    throw new ApiClientError(err, res.status)
  }
  return (await res.json()) as T
}

export const api = {
  exchangeGoogle(body: { code: string; codeVerifier: string; redirectUri: string }) {
    return request<GoogleExchangeResponse>('/api/auth/google/exchange', {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },

  me(token: string) {
    return request<MeResponse>('/api/me', {
      headers: { Authorization: `Bearer ${token}` },
    })
  },

  logout(token: string) {
    return request<{ ok: true }>('/api/auth/logout', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    })
  },
}

export { ApiClientError }
